import { obterClienteDados } from "./obter-dados";

export async function obterBanco(): Promise<unknown> {
  return await obterClienteDados();
}

export async function obterUsuarioCliente(): Promise<any | null> {
  try {
    const banco = await obterClienteDados();
    // If the client provides an `auth.getUser` like Supa-base shim, call it.
    const auth = (banco as any)?.auth;
    if (auth && typeof auth.getUser === "function") {
      const res = await auth.getUser();
      return res?.data?.user ?? null;
    }
    // No auth available client-side; return null.
    return null;
  } catch {
    return null;
  }
}
